// src/components/common/CustomSelect.js
import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({
    value,
    onChange,
    options = [],
    placeholder = "Select",
    disabled = false,
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // Close on outside click
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel =
        options.find((opt) => opt.value === value)?.label || placeholder;

    return (
        <div className="w-full" ref={ref}>
            <div className="relative">
                {/* Trigger */}
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() => !disabled && setOpen(!open)}
                    className={`w-full px-4 py-3 border rounded-xl flex justify-between items-center bg-white text-left
                        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                        ${open ? "border-transparent ring-2 ring-cyan-500" : "border-gray-300"}
                    `}
                >
                    <span className={`text-sm ${value ? "text-gray-900" : "text-gray-400  text-[16px]"}`}>
                        {selectedLabel}
                    </span>
                    <ChevronDown
                        className={`w-5 h-5 transition-transform ${open ? "rotate-180" : ""}`}
                    />
                </button>

                {/* Dropdown */}
                {open && (
                    <div
                        className="
                        absolute left-0 right-0 mt-2 
                        bg-white border border-gray-200 rounded-xl shadow-xl z-50
                        max-h-60 overflow-y-auto
                        "
                    >
                        {options.length === 0 ? (
                            <div className="p-3 text-sm text-gray-500">
                                No options available
                            </div>
                        ) : (
                            options.map((opt, idx) => (
                                <div
                                    key={idx}
                                    onClick={() => {
                                        onChange(opt.value);
                                        setOpen(false);
                                    }}
                                    className={`px-4 py-3 text-sm cursor-pointer hover:bg-gray-100
                                        ${opt.value === value
                                            ? "bg-cyan-50 text-cyan-600 font-medium"
                                            : "text-gray-700"
                                        }
                                    `}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomSelect;
